import React from 'react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Button } from '../../../components/Button'
import * as T from '../../../components/Table'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Flex, Input, Spinner, Text } from '@chakra-ui/react'
import { InputInnovationDoubleDate } from '../../Pedidos/components/InputInnovationDoubleDate'
import { InputInnovationText } from '../../Pedidos/components/InputInnovationText'
import { IoMdClose } from 'react-icons/io'
import { ListItem } from './ListItem'
import { useQuery } from 'react-query'
import { api } from '../../../services/api'
import { addSeconds, parseISO, format } from 'date-fns'
import { phoneMask } from '../../../services/mask'

async function getListCall({ data_entrada, data_saida, consultor }) {
  const response = await api.get('/site/v2/contato/consulta-historico-ligacao/', {
    params: {
      data_entrada,
      data_saida,
      consultor,
    },
  })

  return response.data.map((item) => {
    // Parse da string para objeto Date
    const dataInicio = parseISO(item.inicioLigacao)
    const duracao = parseInt(item.duracao, 10) // converte a duração para número

    // Adicionar a duração em segundos à data de início
    const dataFim = addSeconds(dataInicio, duracao)

    return {
      data: item.data ? format(new Date(item.data), "dd/MM/yyyy 'às' HH:mm") : '',
      consultor: item.consultor,
      atendimento: item.atendimento,
      inicioLigacao: format(dataInicio, "dd/MM/yyyy 'às' HH:mm"), // adiciona o início da ligação
      terminoLigacao: format(dataFim, "dd/MM/yyyy 'às' HH:mm"), // adiciona o término da ligação
      //formatar a duração para exibir em minutos
      duracao: item.duracao ? format(new Date(duracao * 1000), 'mm:ss') : '',
      audio: item.audio,
      telefone: item.telefone ? phoneMask(item.telefone) : '', // aplica a máscara de telefone
    }
  })
}

const schema = z
  .object({
    data_entrada: z.string().optional(),
    data_saida: z.string().optional(),
    consultor: z.string().optional(),
  })
  .superRefine((data) => {
    if (data.data_entrada && !data.data_saida) {
      return { data_saida: 'Campo obrigatório' }
    }

    if (data.data_saida && !data.data_entrada) {
      return { data_entrada: 'Campo obrigatório' }
    }

    return null
  })

export const HistoricoLigacaoVendedor = () => {
  const {
    handleSubmit,
    register,
    formState: { errors },
    watch,
  } = useForm({
    resolver: zodResolver(schema),
  })

  async function onSubmit(data) {
    console.log(data)

    await refetch()
  }

  const watchFields = watch()

  const {
    data: list = [],
    isLoading,
    refetch,
  } = useQuery(
    {
      queryKey: ['historico-ligacao-vendedor'],
      queryFn: () =>
        getListCall({
          data_entrada: watchFields.data_entrada,
          data_saida: watchFields.data_saida,
          consultor: watchFields.consultor,
        }),
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 10,
    }
  )

  return (
    <>
      <HeadingPages name="Histórico de Ligação com Vendedor" />
      <Flex
        alignItems="center"
        justifyContent="space-between"
        w="100%"
        my={5}
        gap={3}
        maxW="1339px"
        mx="auto"
        as="form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <InputInnovationText maxW="202px" w="100%" label="Consultor" name="consultor" {...register('consultor')} />

        <InputInnovationDoubleDate maxW="308px" w="100%">
          <Text color="#378BBF" fontSize="13px" fontWeight="semibold">
            De:
          </Text>
          <Input
            type="date"
            border="0"
            padding="0"
            outline="0"
            boxShadow="0"
            fontSize="13px"
            h="100%"
            _focus={{
              boxShadow: '0',
            }}
            {...register('data_entrada')}
          />
          <Text color="#378BBF" fontSize="13px" fontWeight="semibold">
            Até:
          </Text>
          <Input
            type="date"
            border="0"
            padding="0"
            outline="0"
            fontSize="13px"
            boxShadow="0"
            h="100%"
            _focus={{
              boxShadow: '0',
            }}
            {...register('data_saida')}
          />
        </InputInnovationDoubleDate>

        <Flex alignItems="center" justifyContent="flex-end" gap={2} ml="auto" maxW="340px" w="100%">
          <Button maxW="181px" w="100%" ml="10px" isLoading={isLoading} loadingText="Atualizando..." type="submit">
            Atualizar
          </Button>
          <Button
            bgColor="transparent"
            color="#378bbf"
            border="1px solid #378BBF"
            maxW="131px"
            w="100%"
            ml="5px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={2}
            type="reset"
          >
            <IoMdClose /> Limpar
          </Button>
        </Flex>
      </Flex>

      <T.Table maxW="1339px" mx="auto" borderCollapse="collapse" variant="outline">
        <T.Thead>
          <T.Tr>
            <T.Th>Data</T.Th>
            <T.Th>Consultor</T.Th>
            <T.Th>Atendimento</T.Th>
            <T.Th>Início da Ligação</T.Th>
            <T.Th>Término da Ligação</T.Th>
            <T.Th>Duração</T.Th>
            <T.Th />
          </T.Tr>
        </T.Thead>
        <T.Tbody>
          <ListItem data={list} />
          {isLoading && (
            <T.Tr>
              <T.Td colSpan={7} textAlign="center">
                <Spinner />
              </T.Td>
            </T.Tr>
          )}
        </T.Tbody>
      </T.Table>
    </>
  )
}
